module.exports = __webpack_public_path__ + "static/media/email-invites.85d74c6f.jpg";